import React, { useState } from 'react';
import { Button, Form, InputGroup, Modal } from 'react-bootstrap';
import withTemplate from './JournalTemplates/withTemplate';

const JournalEntryViewer = (props) => {
    const [question, setQuestion] = useState('');
    if(!props.entry) {
        return null;
    }

    const Template = withTemplate(props.entry);

    const noteList = props.entry.notes.map((item, index) => <p key={index}>{item.content}</p>);

    return (
        <Modal show={props.entry} onHide={props.close} size="xl">
            <Modal.Header closeButton><Modal.Title>{props.entry.name}</Modal.Title></Modal.Header>
            <Modal.Body>
                <Template />
                {noteList}
            </Modal.Body>
            <Modal.Footer>
                <InputGroup>
                    <Form.Control type="text" value={question} onChange={(event) => setQuestion(event.target.value)} />
                    <Button variant="secondary" disabled={!question.trim() || props.pending} onClick={() => { props.addNote(props.entry.name, question); setQuestion(''); }}>📝 Add Note</Button>
                    <Button disabled={!question.trim() || props.pending} onClick={() => { props.askAbout(props.entry.name, question); setQuestion(''); }}>💬 Ask Question</Button>
                </InputGroup>
            </Modal.Footer>
        </Modal>
    );
}

export default JournalEntryViewer;